import React, { useContext, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../context/user/UserContext";
import { createQuote } from "../../requests/quoteManagementRequests";
import { useTheme } from "styled-components";
import QuoteTable from "../Quote/QuoteDashboard/QuoteTable";
import guid from "../../modules/guid";
import { PageWrapper } from "../UI/Grid";
import Loading from "../UI/Loading";
import ConfiguratorContext from "../../context/configurator/ConfiguratorContext";

const AllQuotes = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { setQuote } = useContext(ConfiguratorContext);
  const { activeUser, queries, setQueries, pid } = useContext(UserContext);
  const { groupId } = activeUser || {};
  const [isCreating, setIsCreating] = useState(false);

  const onRowClick = (row, e) => {
    e.stopPropagation();
    setQuote({ ...row?.original });
    navigate(`/Quote/${row.original.id}`);
  };

  const onCreateClick = useCallback(async () => {
    setIsCreating(true);
    const newId = guid.GenerateGUID();
    const { id: newQuoteId } = await createQuote({
      input: {
        username: activeUser?.username,
        createdByFirstName: activeUser?.firstName,
        createdByLastName: activeUser?.lastName,
        _id: newId,
        pid,
        createdByUserId: activeUser?.id,
        groupId,
      },
    });
    setIsCreating(false);

    const _queries = { ...queries };
    delete _queries?.quotes;
    setQueries(_queries);

    navigate(`/Quote/${newQuoteId}`);
  }, [activeUser, navigate, queries, setQueries, pid, groupId]);

  return (
    <PageWrapper>
      <QuoteTable
        createButtonText={
          isCreating ? (
            <Loading inline color1={theme.secondary} color2={theme.success} />
          ) : (
            "New Quote"
          )
        }
        allQuotes
        onRowClick={onRowClick}
        createLink={onCreateClick}
      />
    </PageWrapper>
  );
};

export default AllQuotes;
